import Vue from 'vue'
import vuetify from './_vuetify'
import App from './App.vue'
import { i18n, router} from './_helpers'
import store from './_store'
import VueCookies from 'vue-cookies'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, numeric, min, max, min_value, max_value, alpha_num, regex, between } from 'vee-validate/dist/rules'
extend('regex', { ...regex })
extend('alpha_num', { ...alpha_num })
extend('numeric', { ...numeric })
extend('min_value', { ...min_value })
extend('max_value', { ...max_value })
extend('min', { ...min })
extend('max', { ...max })
extend('required', { ...required })
extend('between', {...between})
Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

export const dashboardMixIn = {
    methods: {
        $translatedErrorMessages: function (errors, name, replacements) {
            if (undefined === replacements) {
                replacements = []
            }
            if (errors && Object.keys(errors).length > 0) {
                for (let [key] of Object.entries(errors)) {
                    return this.$t(`msg.${name}_error_${key}`.toString(), replacements)
                }
            }
        }
    }
}
Vue.mixin(dashboardMixIn)

Vue.config.productionTip = false
Vue.use(VueCookies)
new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
    components: { App },
    template: '<App/>'
}).$mount('#app')
